import { useTypedQuery } from "hooks";
import { LeadsQueryKeys } from "modules/LeadsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DropdownItemProps } from "components/Dropdown";
import type { Tag } from "models";

const getSystemTagDropdownOptions = (tags: Tag[]): DropdownItemProps[] =>
  tags.reduce<DropdownItemProps[]>((acc, tag) => {
    if (tag.is_system) acc.push({ key: tag.id, value: tag.id, text: tag.name });
    return acc;
  }, []);

export const useSystemTagOptions = () => {
  const { data: systemTagOptions } = useTypedQuery({
    queryKey: LeadsQueryKeys.tags,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data.tags,
    select: getSystemTagDropdownOptions
  });

  return { systemTagOptions };
};
